import { render } from "./DischargeRequest.vue?vue&type=template&id=766aafe6&scoped=true"
import script from "./DischargeRequest.vue?vue&type=script&lang=js"
export * from "./DischargeRequest.vue?vue&type=script&lang=js"

import "./DischargeRequest.vue?vue&type=style&index=0&id=766aafe6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766aafe6"]])

export default __exports__